import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isReadingPaneStackedView } from 'owa-mail-organization-settings/lib/utils/readingPaneStackedViewUtils';

const NEWEST_ON_BOTTOM_SORT_ORDER = 'ChronologicalNewestOnBottom';

export default function isNewestOnBottom(): boolean {
    // If the reading pane is in stacked view, check the user configuration for the sort order.
    // Otherwise, return false and treat as newest on top
    if (isReadingPaneStackedView(undefined /*listViewType*/)) {
        const userConfiguration = getUserConfiguration();
        const sortOrderFromOptions = userConfiguration.UserOptions
            ? userConfiguration.UserOptions.ConversationSortOrderReact
            : NEWEST_ON_BOTTOM_SORT_ORDER;

        return sortOrderFromOptions == NEWEST_ON_BOTTOM_SORT_ORDER;
    }

    return false;
}
